var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.952.287A.5.5 0 0 0 23.5 0H.5a.501.501 0 0 0-.386.819L10 12.771V23.5a.5.5 0 0 0 .5.5c.13 0 .258-.051.354-.146l3-3A.5.5 0 0 0 14 20.5v-7.729L23.885.819a.5.5 0 0 0 .067-.532"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-on.svg";